import global from "@/locales/en-GB/global";
import loginPageSteps from "@/locales/en-GB/loginPageSteps";
import error403 from "@/locales/en-GB/errors/403";
import error404 from "@/locales/en-GB/errors/404";
import error500 from "@/locales/en-GB/errors/500";
import error503 from "@/locales/en-GB/errors/503";
import error504 from "@/locales/en-GB/errors/504";
import maintenance from "@/locales/en-GB/auth/maintenance";
import onboarding from "@/locales/en-GB/auth/onboarding";
import bankstatement from "@/locales/en-GB/account/bankstatement";
import myApps from "@/locales/en-GB/my-apps/myApps";
import contactService from "@/locales/en-GB/about/contactService";
import salesPromotions from "@/locales/en-GB/sales/promotions";
import brochures from "@/locales/en-GB/sales/brochures";
import dashboard from "@/locales/en-GB/dashboard/dashboard";
import staff from "@/locales/en-GB/dashboard/staff";
import account from "@/locales/en-GB/account/account";
import promotions from "@/locales/en-GB/promotions";
import points from "@/locales/en-GB/points";
import shop from "@/locales/en-GB/shop/data";
import priceList from "@/locales/en-GB/shop/priceList";
import trainings from "@/locales/en-GB/trainings/trainings";
import vouchers from "@/locales/en-GB/vouchers/vouchers";
import widgets from "@/locales/en-GB/widgets/widgets";
import generateReport from "@/locales/en-GB/generate-report/generateReport";
import wholesaler from "@/locales/en-GB/wholesaler/wholesaler";
import media from "@/locales/en-GB/media/index";
import product from "@/locales/en-GB/product/index";
import message from "@/locales/en-GB/message/index";
import commitmentLetter from "@/locales/en-GB/account/commitmentLetter";
import multiplicator from "@/locales/en-GB/multiplicator";
import toast from "@/locales/en-GB/toast/toast";
import consents from "@/locales/en-GB/consents/consents";
import investment from "@/locales/en-GB/investment/data";
import publicCountryNotice from "@/locales/en-GB/publicCountryNotice";
import kickback from "@/locales/en-GB/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  publicCountryNotice: publicCountryNotice.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  onboarding: onboarding.messages,
  bankstatement: bankstatement.messages,
  myApps: myApps.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  staff: staff.messages,
  account: account.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures:brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  generateReport: generateReport.messages,
  widgets: widgets.messages,
  wholesaler: wholesaler.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  toast: toast.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Product Images",
    BDriveLinkText: "Link to the PRODUCT IMAGES portal",
  },
}

export default {
  locale: "en-GB",
  messages,
};
